export default {
  '临床研究总监': 'Senior VP of clinical Development  /  临床研究总监',
  '项目经理': 'Project Manager  / 项目经理',
  '高级临床监查员': 'Senior CRA / CRA   高级临床监查员 / 临床监查员 ',
  '项目专员': 'Project Administrator  /  项目专员',
  '注册经理': 'Head Regulatory Affairs  /  Regulatory Manager  /  注册经理 '
}